import {
  isMarketplaceAuction,
  isMarketplaceDraw,
} from '~admin/view/components/details/helper/marketplace.helper';
import { MarketplaceType } from '~client/model/marketplace-type';

/**
 * Show "minManualPaymentDurationSeconds" and "maxManualPaymentDurationSeconds" fields
 * if selected marketplace type is auction or draw
 * @param type
 */
export const showFixPaymentFields = (type: MarketplaceType): boolean =>
  isMarketplaceDraw(type) || isMarketplaceAuction(type);



// WEBPACK FOOTER //
// ./view/components/details/marketplace-details/marketplace-datetime-details/marketplace-datetime-details.helper.ts